require('./score-card.jade')
_ = require("lodash")

EventScoreCardDirective = ($window,$location) ->
  restrict: "A"
  replace: false
  templateUrl: "group-event/event-score-card-directive/score-card.jade"
  scope:
    datas: '=scorelist'
    user_id: '=userid'
    event_id: '=eventid'
    hide_detail: '=hidedetail'
  link: (scope) ->
    scope.isShowDetail = false
    scope.gotoAnalysisScorecard = (score_card_id)  ->
      url = '/round-detail/'+ score_card_id+'?user_id=' + scope.user_id + '&event_id='+scope.event_id
      $window.location.href = url
    scope.showDetail = ->
      scope.isShowDetail = !scope.isShowDetail
    scope.classForRoundIcons = (scoreCard) ->
      return unless scoreCard.round_type
      switch scoreCard.round_type
        when 1.5 then 'icons-extra9'
        when 0.5 then 'icons-half-nine'
        else ''

EventScoreCardDirective.$inject = [
  '$window'
  '$location'
]

module.exports = EventScoreCardDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-event/event-score-card-directive/event-score-card-directive.coffee